<div class="picker" [class.picker--disabled]="disabled()">
  <!-- ═════════ formato ═════════ -->
  <p class="picker__eyebrow" id="briefing-format-label">Formato</p>
  <!-- Radiogroup ARIA completo (achado 1 da revisão do Q4): uma parada de Tab só (tabindex itinerante, 0 no marcado),
       setas e Home/End movem o foco e escolhem; o Completo travado recebe o foco (mostra o aviso) sem ser escolhido. -->
  <div
    class="segmented"
    role="radiogroup"
    aria-labelledby="briefing-format-label"
    (keydown)="onFormatKeydown($event)">
    <button
      #formatOption
      type="button"
      role="radio"
      class="segmented__option"
      [class.segmented__option--on]="format() === 'summary'"
      [attr.aria-checked]="format() === 'summary'"
      [attr.tabindex]="format() === 'summary' ? 0 : -1"
      [disabled]="disabled()"
      (click)="choose('summary')">
      <span class="segmented__title">Resumido</span>
      <span class="segmented__hint">até 3 páginas</span>
    </button>
    <!-- Completo: travado na fase 1. `aria-disabled` em vez de `disabled` para continuar focável e o aviso
         aparecer também no foco do teclado, não só no mouse. -->
    <button
      #formatOption
      type="button"
      role="radio"
      class="segmented__option segmented__option--locked"
      aria-checked="false"
      aria-disabled="true"
      tabindex="-1"
      [attr.aria-label]="'Completo. ' + completeLockedHint"
      [pTooltip]="completeLockedHint"
      tooltipPosition="bottom"
      tooltipEvent="both">
      <span class="segmented__title"
        >Completo <i class="pi pi-lock segmented__lock" aria-hidden="true"></i
      ></span>
      <span class="segmented__hint">em breve</span>
    </button>
    <button
      #formatOption
      type="button"
      role="radio"
      class="segmented__option"
      [class.segmented__option--on]="isCustom()"
      [attr.aria-checked]="isCustom()"
      [attr.tabindex]="isCustom() ? 0 : -1"
      [disabled]="disabled()"
      (click)="choose('custom')">
      <span class="segmented__title">Personalizado</span>
      <span class="segmented__hint">você escolhe</span>
    </button>
  </div>
  <p class="picker__summary">{{ formatSummary() }}</p>

  <!-- ═════════ roteiro do PDF ═════════ -->
  <div class="picker__roadmap-head">
    <p class="picker__eyebrow" id="briefing-roadmap-label">Roteiro do PDF</p>
    @if (!isCustom()) {
      <button
        type="button"
        class="picker__adjust"
        [disabled]="disabled()"
        (click)="choose('custom')">
        Ajustar seções
      </button>
    }
  </div>

  <!-- `ul` e não `ol` (achado 3): a numeração do PDF é visual e só conta o que entra; a lista nativa contaria também
       as seções fora e travadas, e o leitor de tela diria "item 6 de 8" onde o círculo mostra "4". -->
  <ul class="roadmap" role="list" aria-labelledby="briefing-roadmap-label">
    @for (row of rows(); track row.key) {
      <!-- Anexo (Investigação, card 3911): fora do teto de páginas do corpo. -->
      @if (row.startsAnnex) {
        <li class="roadmap__break roadmap__break--annex" aria-hidden="true">
          <span class="roadmap__break-line"></span>
          <span>Anexo</span>
          <span class="roadmap__break-tail"></span>
        </li>
      }
      @if (row.startsPage) {
        <li class="roadmap__break" aria-hidden="true">
          <span class="roadmap__break-line"></span>
          <span>Página {{ row.startsPage }}</span>
          <span class="roadmap__break-tail"></span>
        </li>
      }

      @if (row.state === 'locked') {
        <li class="roadmap__item roadmap__item--locked">
          <span class="roadmap__number roadmap__number--locked" aria-hidden="true"
            ><i class="pi pi-lock"></i
          ></span>
          <div class="roadmap__text">
            <p class="roadmap__name">
              {{ row.name }}
              <span class="roadmap__phase">{{ lockedLabel(row) }}</span>
            </p>
            <p class="roadmap__note">{{ row.description }}</p>
          </div>
        </li>
      } @else {
        <li
          class="roadmap__item"
          [class.roadmap__item--clickable]="
            isCustom() && (row.state === 'in' || row.state === 'out')
          "
          [class.roadmap__item--out]="row.state === 'out'"
          [title]="row.description"
          (click)="toggleRow(row)">
          <span
            class="roadmap__number"
            [class.roadmap__number--always]="row.state === 'always'"
            [class.roadmap__number--in]="row.state === 'in'"
            aria-hidden="true"
            >{{ row.position ?? '–' }}</span
          >
          <div class="roadmap__text">
            <p class="roadmap__name">
              {{ row.name }}
              @if (row.detail) {
                <span class="roadmap__detail">{{ row.detail }}</span>
              }
            </p>
            <!-- Subseções (Investigação): fechadas por padrão; o botão abre a lista logo abaixo. -->
            @if (row.children.length) {
              <button
                type="button"
                class="roadmap__children-toggle"
                [attr.aria-expanded]="isExpanded(row.key)"
                [attr.aria-controls]="'briefing-children-' + row.key"
                (click)="toggleExpanded($event, row.key)">
                {{ childrenSummary(row) }}
                <i
                  class="pi pi-chevron-down"
                  [class.roadmap__chevron--open]="isExpanded(row.key)"
                  aria-hidden="true"></i>
              </button>
            }
          </div>

          @if (row.state === 'always') {
            <span class="roadmap__state roadmap__state--always"
              ><i class="pi pi-lock" aria-hidden="true"></i>sempre</span
            >
          } @else if (isCustom()) {
            <button
              type="button"
              role="switch"
              class="switch"
              [class.switch--on]="row.state === 'in'"
              [attr.aria-checked]="row.state === 'in'"
              [attr.aria-label]="'Incluir ' + row.name"
              [disabled]="disabled()"
              (click)="toggleSwitch($event, row)"></button>
          } @else {
            <span class="roadmap__state" [class.roadmap__state--in]="row.state === 'in'">
              {{ row.state === 'in' ? 'entra' : 'fora' }}
            </span>
          }
        </li>

        @if (row.children.length && isExpanded(row.key)) {
          <li class="roadmap__children" [id]="'briefing-children-' + row.key">
            <ul
              class="roadmap__child-list"
              role="list"
              [attr.aria-label]="'Subseções de ' + row.name">
              @for (child of row.children; track child.key) {
                <li
                  class="roadmap__child"
                  [class.roadmap__child--out]="row.state !== 'in' || child.state === 'out'"
                  [class.roadmap__child--clickable]="
                    isCustom() &&
                    row.state === 'in' &&
                    (child.state === 'in' || child.state === 'out')
                  "
                  [title]="child.description"
                  (click)="toggleChild($event, row, child)">
                  <span class="roadmap__child-dot" aria-hidden="true"></span>
                  <span class="roadmap__child-name">{{ child.name }}</span>
                  @if (child.state === 'locked') {
                    <span class="roadmap__state">indisponível</span>
                  } @else if (child.state === 'auto') {
                    <span
                      class="roadmap__state"
                      pTooltip="Vai junto sempre que uma subseção de pesquisa na internet está marcada."
                      tooltipPosition="left"
                      >{{ row.state === 'in' ? 'vai junto' : 'fora' }}</span
                    >
                  } @else if (isCustom() && row.state === 'in') {
                    <button
                      type="button"
                      role="switch"
                      class="switch switch--small"
                      [class.switch--on]="child.state === 'in'"
                      [attr.aria-checked]="child.state === 'in'"
                      [attr.aria-label]="'Incluir ' + child.name"
                      [disabled]="disabled()"
                      (click)="toggleChild($event, row, child)"></button>
                  } @else {
                    <span
                      class="roadmap__state"
                      [class.roadmap__state--in]="row.state === 'in' && child.state === 'in'">
                      {{ row.state === 'in' && child.state === 'in' ? 'entra' : 'fora' }}
                    </span>
                  }
                </li>
              }
            </ul>
          </li>
        }
      }
    }
  </ul>
</div>
